import { render, staticRenderFns } from "./playersBody.vue?vue&type=template&id=31129844&scoped=true&"
import script from "./playersBody.vue?vue&type=script&lang=js&"
export * from "./playersBody.vue?vue&type=script&lang=js&"
import style0 from "./playersBody.vue?vue&type=style&index=0&id=31129844&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31129844",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSnackbar } from 'vuetify/lib/components/VSnackbar';
installComponents(component, {VCol,VRow,VSnackbar})
